import { render } from "./Widget.vue?vue&type=template&id=d4275602&scoped=true&ts=true"
import script from "./Widget.vue?vue&type=script&lang=ts"
export * from "./Widget.vue?vue&type=script&lang=ts"

import "./Widget.vue?vue&type=style&index=0&id=d4275602&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4275602"]])

export default __exports__